export { default, StyledPlaceholder } from './Note';
